export enum ResultListHitType {
    HIT = "HIT",
    INJECTED = "INJECTED",
}
